module.exports = __webpack_public_path__ + "static/img/receipt_2_amigos.2d8306b4.jpg";